import React from "react";
import Bundles from "src/pages/watcher/Bundles";
import ShowBundle from "src/pages/watcher/Bundles/Show";
import R2Files from "src/pages/watcher/R2Files";

const watcherRoutes = [
  { path: '/bundles', element: <Bundles /> },
  { path: '/bundles/:id',   element: <ShowBundle /> },
  { path: '/r2-files', element: <R2Files /> },
]

export default watcherRoutes;
